export default __webpack_public_path__ + "static/media/p_5.4fc9e7d9.jpg";